import React from 'react';
import { X } from 'lucide-react';

const ImageLightbox = ({ isOpen, onClose, imageUrl, title, allowZoom = true, zIndex = 60 }) => {
  if (!isOpen || !imageUrl) return null;

  const handleClose = () => {
    onClose();
  };

  const handleImageClick = e => {
    e.stopPropagation();
    // No zoom functionality - prevent click from bubbling to backdrop
  };

  const handleBackdropClick = e => {
    // Only close if clicking directly on the backdrop, not on child elements
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-90`}
      style={{ zIndex }}
      onClick={handleBackdropClick}
    >
      {/* Close Button - Fixed to top right */}
      <button
        onClick={e => {
          e.stopPropagation();
          handleClose();
        }}
        className="fixed top-8 right-8 text-white hover:text-gray-300 z-10 bg-black bg-opacity-75 rounded-full p-3 transition-colors"
        title="Close (Esc)"
      >
        <X size={28} />
      </button>

      {/* Image - Centered with absolute positioning */}
      <img
        src={imageUrl}
        alt=""
        className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 object-contain transition-all duration-300 shadow-2xl max-w-[95vw] max-h-[90vh]"
        onClick={handleImageClick}
        onError={e => {
          console.error('Image failed to load:', imageUrl);
          // Optionally show a placeholder or error message
        }}
      />

      {/* Title/Caption */}
      {title && (
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 bg-black bg-opacity-75 text-white px-4 py-2 rounded-lg max-w-[80%] text-center">
          <p className="text-lg font-medium truncate">{title}</p>
        </div>
      )}
    </div>
  );
};

export default ImageLightbox;
